window.ready = function ready(callback) {
    // in case the document is already rendered
    if (document.readyState !== 'loading') {
        callback();
    }
    // modern browsers
    else if (document.addEventListener) {
        document.addEventListener('DOMContentLoaded', callback);
    }
    // IE <= 8
    else {
        document.attachEvent('onreadystatechange', function(){
            if (document.readyState === 'complete') callback();
        });
    }
};

window.createElement = (tagElement, classNames, attributes) => {
    const element = document.createElement(tagElement);
    if (classNames) {
        element.classList.add(...classNames);
    }
    if (attributes) {
        for (const attribute in attributes) {
            element[attribute] = attributes[attribute];
        }
    }
    return element;
};
window.getElement = (tagElement, classNames, attributes) => {
    const element = document.createElement(tagElement);
    if (classNames) {
        element.classList.add(...classNames);
    }
    if (attributes) {
        for (const attribute in attributes) {
            element[attribute] = attributes[attribute];
        }
    }
    return element;
};

window.addEventListener('scroll', function() {
    document.documentElement.style.setProperty('--scroll-y', window.scrollY + 'px');
});

(function($) {

    // БЛОЧИМ ПОЛОСУ ПРОКРУТКИ У СТРАНИЦЫ
    $.fn.pageScrollHide = function(options) {
        var scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
        var body = document.body;
        body.style.position = 'fixed';
        body.style.top = '-' + scrollY;
        body.style.width = '100%';
        body.style.left = 0;
    }

    // РАЗРЕШАЕМ ПОЛОСУ ПРОКРУТКИ У СТРАНИЦЫ
    $.fn.pageScrollShow = function(options) {
        var body = document.body;
        var scrollY = body.style.top;
        body.style.position = '';
        body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }

    /*
    * ФОТОГАЛЕРЕЯ
    * проставляем title у ссылок изображений
    * инициализируем (подключаем) либу фотогалереи
    */
    window.lightGallery = function(block, a) {
        $(block).find(a).each(function() {
            $(this).attr("data-sub-html", $(this).find("img").attr("title"));
        });
        $(block).lightGallery({
            selector: a,
            download: false,
            fullScreen: false,
            zoom: false,
            share: false,
            thumbnail: true
        });
    };

    /*
    * Переход к якорю (плавно)
    *
    * USED:
    * $('class_блока').scrollingToElement();
    *
    * Параметры по умолчанию:
    * selector: 'a[href^="#"]'    — указываем selector, class, id
    * offsetTop: 0,               — отступ от края экрана
    * speed: 300                  — скорость анимации
    */
    $.fn.scrollingToElement = function(options) {
        var elem = this;
        options = $.extend({
            selector: "a[href^=\"#\"]",
            offsetTop: 0,
            speed: 300
        }, options);
        return this.each(function() {
            elem.find(options.selector).click(function() {
                var el = $(this).attr("href");
                $("body, html").animate({
                    scrollTop: $(el).offset().top - options.offsetTop
                }, options.speed);
                return false;
            });
        });
    };

    // БЛОКИРУЕМ ИЛИ РАЗРЕШАЕМ ПОЛОСУ ПРОКРУТКИ У СТРАНИЦЫ
    // window.addEventListener("scroll", function() {
    //     document.documentElement.style.setProperty("--scroll-y", window.scrollY + "px");
    // });
    // $.fn.pageScrollHide = function(options) {
    //     var scrollY = document.documentElement.style.getPropertyValue("--scroll-y");
    //     var body = document.body;
    //     body.style.position = "fixed";
    //     body.style.top = "-" + scrollY;
    //     body.style.width = "100%";
    //     body.style.left = 0;
    // };
    // $.fn.pageScrollShow = function(options) {
    //     var body = document.body;
    //     var scrollY = body.style.top;
    //     body.style.position = "";
    //     body.style.top = "";
    //     window.scrollTo(0, parseInt(scrollY || "0") * -1);
    // };

})(jQuery);
